// SPDX-FileCopyrightText: 2024 LiveKit, Inc.
//
// SPDX-License-Identifier: Apache-2.0
import {version as v} from '../package.json';

export const version = v;
export const protocolVersion = 16;
